import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledErrorImage = styled(SWReactIcons)`
    width: 155px;
`;

export const StyledTitle = styled.h3`
    ${mixins.setFontVariant("subtitle1", colorsPalettes.carbon["500"])};

    margin: 0 0 8px;
    line-height: 20px;
`;

export const StyledSubTitle = styled.p`
    ${mixins.setFontVariant("caption", colorsPalettes.carbon["300"])};

    margin: 0;
    line-height: 20px;
`;
